import { Field } from "formik";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function TreeProfile({ formField }) {
  const { treeCadastreNo, name } = formField;
  const { t } = useTranslation();

  const TREE_CADASTRE_LIMIT = 24;
  const NAME_LIMIT = 40;

  return (
    <div className="d-flex flex-column w-100 gap-2">
      <div className="d-flex align-item-center w-100 gap-2">
        <Form.Group className="w-50">
          <Form.Label>
            {t(treeCadastreNo.label)} <span className="text-danger">*</span>
          </Form.Label>
          <Field
            type="text"
            name={treeCadastreNo.name}
            className="form-control "
            maxLength={TREE_CADASTRE_LIMIT}
            placeholder={t("maximum_of") + ` ${TREE_CADASTRE_LIMIT} ` + t("characters")}
          />
        </Form.Group>
        <Form.Group className="w-50">
          <Form.Label>
            {t(name.label)} <span className="text-danger">*</span>
          </Form.Label>
          <Field
            type="text"
            name={name.name}
            className="form-control "
            maxLength={NAME_LIMIT}
            placeholder={t("maximum_of") + ` ${NAME_LIMIT} ` + t("characters")}
          />
        </Form.Group>
      </div>
      <small className="text-muted">{t("validation.required_fields")}</small>
    </div>
  );
}
